import DOMPurify from 'dompurify';

const sanitizeMarkup = (html) => {
  return {
    __html: DOMPurify.sanitize(html),
  };
};

export { sanitizeMarkup };
